import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
// import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles } from '../style/GlobalStyles';

// const useStyles = makeStyles({
//     // root: {
//     //     flexGrow: 1,
//     // },
//     closeButton: {
//         display: 'flex',
//         justifyContent: 'flex-end',
//         alignItems: 'center',
//         marginTop: '2rem',
//         marginBottom: '1rem',
//     },
// });

type ProgressBarProps = {
    isOpen: boolean;
}

export default function ProgressBar(props: ProgressBarProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    
    return (
        <div className={gClasses.root}>
            <Dialog
                open={props.isOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Elaborazione in corso, attendere prego"}</DialogTitle>
                <DialogContent>
                    <React.Fragment>
                        <Typography style={{ marginBottom: '10px', textAlign: 'center' }} variant="subtitle2" color={"initial"}>Elaborazione in corso</Typography>
                        <LinearProgress variant="indeterminate" />
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        </div>
    );

}